export default function (...args)
{
	return {
		regex: /^(\d{1,15})$/,
	};
}

